
<div fxLayout="row">
    <div fxFlex="75" fxFlex.lt-sm="100" class="prot space-product" fxLayout="column"
      fxLayoutAlign="space-evenly start" fxLayoutGap="6px">
      <span *ngIf="specialPrice>0&& (product.specialPrice != product.price)">
        <span *ngIf="data.displayMrpPrice">
          <b>MRP :</b>
        </span>
        <s class="old-price font-16px">
          {{price |currencyConvert }}{{units}} {{AmountType}}
        </s>
      </span>
      <span class="price-label font-16px padding-3" *ngIf="specialPrice <= 0">
        <span *ngIf="data.displayMrpPrice">
          <b>MRP :</b>
        </span>
        {{price |currencyConvert }}{{units}} {{unitPrice}}
      </span>

      <!-- <span class="price-label font-16px" *ngIf="specialPrice > 0">
        {{specialPrice |currencyConvert }}{{units}} {{unitSpecialPrice}}
        <span class="product-Price ">
         
          <span class="cursor-text" style="cursor: text;" *ngIf="discountPercentage > 0">
            ({{discountPercentage | dynamicRound }}<small>%</small> OFF)
          </span>
        </span>
      </span> -->
      <span class="price-label font-16px" *ngIf="specialPrice > 0" style="display: inline-flex; align-items: center;">
        {{specialPrice | currencyConvert}}{{units}} {{unitSpecialPrice}}
        <span class="product-Price" *ngIf="discountPercentage > 0" style="margin-left: 8px; white-space: nowrap;cursor: text;">
          ({{discountPercentage | dynamicRound }}<small>%</small> OFF)
        </span>
      </span>
      


    </div>

    <div fxHide fxShow.gt-sm fxFlex="25">

    </div>
  </div>